// Shared, single-source-of-truth list of organisation-scoped permission
// keys, split out of AdminComponents.js so it can be imported by both
// AdminComponents.js (Role Management -> Organisation Permissions tab) and
// MemberPermissionOverridePanel.js (Mantis #1390 / M004-F0618 §D.4's
// per-person override panel) WITHOUT a circular import between the two —
// AdminComponents.js already imports MemberPermissionOverridePanel.js to
// render it, so the reverse import (this file used to live inline in
// AdminComponents.js) broke module evaluation order in Jest (and would have
// been equally fragile under webpack): `ORGANISATION_PERMISSION_KEYS.filter`
// ran while AdminComponents.js was still mid-evaluation, before its own
// `export const ORGANISATION_PERMISSION_KEYS` line had executed.
//
// Mirrors `permissionPolicy.service.ts`'s ORGANISATION_PERMISSION_KEYS on
// Core (`src/services/permissionPolicy.service.ts`) — additions/removals
// there must be mirrored here.
export const ORGANISATION_PERMISSION_KEYS = [
  'organisation_settings_update',
  'organisation_users_add',
  'organisation_users_remove',
  'organisation_users_role_change',
  'rooms_view',
  'rooms_manage',
  'bookings_create',
  'bookings_manage_all',
  'bookings_manage_own',
  'documents_review',
  'documents_manage_own',
  'invoices_manage',
  'security_policy_manage',
  // Mantis #1390 / M004-F0618 §D.2 (Core MR !571, #1385, M005-F0048):
  // pricing.routes.ts's dedicated tri-state keys, previously the coarse
  // invoices_manage/ledger_read. Adding them here is the entire WebUI
  // change needed for role-level grant/revoke (§D.3) — this array already
  // drives both the Role Management -> Organisation Permissions toggle
  // matrix (permission-toggle-organisation-<role>-<key>) and the per-person
  // override panel (MemberPermissionOverridePanel.js), which imports this
  // same array so the two editors can never drift apart.
  'pricing_plans_view',
  'pricing_plans_manage',
  'pricing_member_plan_assign',
  'pricing_booking_reprice',
];

export const formatPermissionLabel = (key) => key.replace(/_/g, ' ');
